/**
 * Cell
 *
 * @author edmsamuel
 */
import React from 'react';
import { Input, Checkbox, Select, DatePicker } from 'antd';
import Callback from '../Callback';

export default class Cell extends React.Component {
  static buildList(items = []) {
    return items
      .filter(item =>
        item.dataIndex !== 'iId' && item.dataIndex[0] !== '_'
      ).map((item, idx) => ({
        key: idx,
        ...item,
        title: (item.title ?
          item.title :
          item.dataIndex.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2')
        )
      })
    );
  }


  /**
   * Select
   *
   * @param {Any} value
   */
  select(value) {
    const options = this.props.options || []

    const props = {
      style: { minWidth: 107 },
      ...this.props,
      defaultValue: value,
      onChange: value => Callback.execute(this.props.onChange, value),
    };

    return (
      <Select {...props} >
        {options.map(opt => (
          <Select.Option key={opt.key} value={opt.key}>{opt.value}</Select.Option>
        ))}
      </Select>
    );
  }


  /**
   * Checkbox
   *
   * @param {boolean} value
   */
  checkbox(value) {
    return (
      <Checkbox
        checked={value}
        onChange={e => Callback.execute(this.props.onChange, e.target.checked)}
        />
    );
  }

  /**
   * Input
   *
   * @param {Any} value
   */
  text(value) {
    return (
      <Input
        {...this.props}
        type={this.props.inputType || this.props.type}
        value={value}
        onChange={e => Callback.execute(this.props.onChange, e.target.value)}
        />
    );
  }

  /**
   * Input
   *
   * @param {Any} value
   */
   textArea(value) {
    return (
      <Input.TextArea
        {...this.props}
        value={value}
        onChange={e => Callback.execute(this.props.onChange, e.target.value)}
        />
    );
  }

  /**
   * File
   *
   */
  file() {
    return (
      <input type='file' {...this.props} />
    );
  }

  /**
   * Image
   *
   */
  image() {
    return (
      <img
        className={this.props.className}
        src={this.props.src}
        alt={this.props.alt}
        style={this.props.style} />
    );
  }

  /**
   * Date
   *
   */
  date() {
    return (
      <DatePicker {...this.props} />
    );
  }

  /**
   * Plain
   *
   */
  plain() {
    const value = `${this.props.value}`.trim();

    return value.split('\n').map((item, key) =>
      (<span key={key}> {item} <br/></span>)
    );
  }

  /**
   * Render
   *
   */
  render() {
    switch (this.props.type) {
      case 'text':
        return this.text(this.props.value);

      case 'textArea':
        return this.textArea(this.props.value);

      case 'checkbox':
        return this.checkbox(this.props.value);

      case 'select':
        return this.select(this.props.value);

      case 'file':
        return this.file(this.props.value);

      case 'image':
        return this.image(this.props.value);

      case 'date':
        return this.date(this.props.value);

      default:
        return this.plain();
    }
  }
}
